/**
 * Application Entry Point
 *
 * This is the main entry file for the Datastage SPA application.
 * It sets up the core providers and renders the app into the DOM.
 *
 * Architecture Overview:
 * - Redux Provider: Global state management (see shared/redux/store.js)
 * - BrowserRouter: Client-side routing with React Router v6
 * - Core: Main application component handling auth and routing
 *
 * @see src/Core.jsx - Main application wrapper
 * @see src/shared/redux/store.js - Redux store configuration
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from 'shared/redux/store';
import { BrowserRouter } from 'react-router-dom';
import { FeatureFlagProvider } from 'datastage/context/FeatureFlagContext';
import { Core } from './Core';
import 'shared/assets/styles/_base.scss';

const rootElement = document.getElementById('root');

if (rootElement) {
    const root = createRoot(rootElement);

    root.render(
        <Provider store={store}>
            <FeatureFlagProvider>
                {/* Future flags opt-in for React Router v7 compatibility */}
                <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <Core />
                </BrowserRouter>
            </FeatureFlagProvider>
        </Provider>,
    );
} else {
    console.error('Root element not found!');
}
